import callCmAPI from 'services/helpers/call-cm-api'
import {
  CreateCustomerGroupDataT,
  CustomerGroupT,
  WebApi2Response,
} from 'types/global'

/**
 * Creates a new customer group.
 *
 * CMAPI fills `created_by` from the Firebase token — never trust it
 * from the client. Any duplicate name surfaces as a 400 from the
 * server; the calling mutation hook converts that into a snackbar.
 */
export const createCustomerGroup = (
  body: CreateCustomerGroupDataT,
): Promise<WebApi2Response<CustomerGroupT>> =>
  callCmAPI('/customer-group', {
    method: 'post',
    data: body,
  }).then(({ data }) => {
    return data
  })
